<template>
  <div>
    <div class="field">
      <div class="name">
        <span class="flag">*</span>
        <span class="b-title">所在城市</span>
        <span class="warn" v-if="!regCity">此处不能为空</span>
      </div>
      <div class="city-input">
        <div class="each-city-input">
          <div class="input-name">国家：</div>
          <i-select
          v-model="country">
            <i-option v-for="item in countrys" :value="item.id" :key="item.id">{{ item.name }}</i-option>
          </i-select>
        </div>
        <div class="each-city-input" v-if="provinces.length">
          <div class="input-name">省份：</div>
          <i-select
          v-model="province">
            <i-option v-for="item in provinces" :value="item.id" :key="item.id">{{ item.name }}</i-option>
          </i-select>
        </div>
        <div class="each-city-input">
          <div class="input-name">城市：</div>
          <i-select
          v-model="city">
            <i-option v-for="item in citys" :value="item.id" :key="item.id">{{ item.name }}</i-option>
          </i-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import tgoSelect from '@/components/form/select'
import areaData from '@/config/areaData'
import Select from '@/components/form/iview/components/select'
import Option from '@/components/form/iview/components/option'

export default {
  data () {
    return {
      areaData,
      countrys: [
        { id: 1, name: '中国' },
        { id: 2, name: '美国' },
        { id: 3, name: '新加坡' }
      ],
      provinces: [],
      citys: []
      // selectedValue: {}
    }
  },
  components: {
    // tgoSelect,
    iSelect: Select,
    iOption: Option
  },
  props: ['regCity', 'info'],
  methods: {
    getProvince (value) {
      if (value === 1) {
        this.$emit('exportValue', { key: 'country', value: 1 })
        this.provinces = this.areaData['86'].filter(item => item.cid === 1)
        this.province = ''
        this.city = ''
        this.$emit('exportValue', { key: 'province', value: '' })
        this.$emit('exportValue', { key: 'city', value: '' })
      } else if (value === 2 || value === 3) {
        this.$emit('exportValue', { key: 'country', value })
        this.$emit('exportValue', { key: 'province', value: 0 })
        this.citys = this.areaData[value === 2 ? '9999' : '9998'].childs
        this.provinces = []
        this.city = ''
        this.$emit('exportValue', { key: 'city', value: '' })
      }
    },
    getCity (value) {
      if (!value) return
      this.citys = []
      this.city = ''
      this.$emit('exportValue', { key: 'province', value: value })
      // this.selectedValue['province'] = value
      if (this.areaData[value].childs) {
        this.citys = this.areaData[value].childs
      }
    },
    exportCity (value) {
      this.$emit('exportValue', { key: 'city', value: String(value) === 'undefined' ? '' : value })
    }
  },
  computed: {
    country: {
      get: function () {
        let cnumber = Number(this.info['country'])
        return cnumber
      },
      set: function (n) {
        this.getProvince(n)
      }
    },
    province: {
      get: function () {
        let pnumber = Number(this.info['province'])
        return pnumber
      },
      set: function (n) {
        this.getCity(n)
      }
    },
    city: {
      get: function () {
        return Number(this.info['city'])
      },
      set: function (n) {
        this.exportCity(n)
      }
    }
  },
  watch: {
    country: {
      handler: function (n) {
        if (n === 1) {
          this.provinces = this.areaData['86'].filter(item => item.cid === 1)
        } else if (n === 2 || n === 3) {
          this.provinces = []
          this.citys = this.areaData[n === 2 ? '9999' : '9998'].childs
        }
      },
      immediate: true
    },
    province: {
      handler: function (n) {
        if (n && this.areaData[n].childs) {
          this.citys = this.areaData[n].childs
        }
      },
      immediate: true
    }
  }
}
</script>
<style scoped lang='sass'>
@import '../../../../../style/bulma/app'

.field
  margin-bottom: 18px
  .name
    margin-bottom: 8px
    display: flex
    align-items: center
    transition: all 1s linear
    .b-title
      margin-right: 15px
    .flag
      color: $primary3
      font-size: 24px
      margin-right: 5px
    .warn
      font-size: 18px
      color: $primary3
  .city-input
    margin-left: 48px
    display: flex
    .each-city-input
      display: flex
      align-items: center
      width: 33.333%
      margin-right: 20px
      .input-name
        width: 70px
        word-break: keep-all
      &:last-child
        margin-right: 0
      .tgo-select
        flex-grow: 1
</style>
